const getPurchaseMethod = (type) => {
  return type === 1
    ? 'از طریق یونید'
    : type === 2
    ? 'خرید حضوری'
    : type === 3
    ? 'از طریق سایت شخصی'
    : '';
};

export { getPurchaseMethod };
